<div
  class="d-flex align-items-center mr-auto"
  [ngClass]="{ 'set-cursor': isClickable }"
>
  <a *ngIf="logoPath" (click)="isClickable ? navigateToRoutePage() : false">
    <img [src]="logoPath" class="app-logo d-block ml-3" [alt]="logoAlt" />
  </a>
  <a routerLink="/app" *ngIf="appName">
    <h1 class="app-name ml-2" [ngClass]="{ 'app-name-white': isBlue }">
      {{ appName }}
    </h1>
  </a>
  <span *ngIf="beta" class="badge badge-warning ml-2">BETA</span>
</div>
